import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const FooterModal = ({ show, onHide, title, children }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton style={{ background: '#690C68', borderBottom: '1px solid #8a0e89' }}>
                <Modal.Title style={{ color: '#fff', fontWeight: 600, fontSize: '1.1rem' }}>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', padding: '24px' }}>
                {children}
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #eee' }}>
                <Button
                    onClick={onHide}
                    style={{
                        background: '#690C68',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '8px 20px',
                        fontWeight: 500,
                    }}
                >
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default FooterModal;